import { copy } from '..';
export const cbForCopy = (destinationPath, destinationRepository, configParams) => (sources) => copy(sources, destinationPath, destinationRepository, configParams);
